<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <Home></Home>
  </div>
</template>

<script>
import Home from './views/Home'

export default {
  components:{
    Home
  }
}
</script>

<style lang="stylus">
@import '~styles/icons.css'
@import '~styles/common.stylus'
@font-face {
  font-family: 'Alibaba PuHuiTi Medium';
  src: url('https://cdn.vcbeat.top/upload/vcbeat/vbList2020/font/Alibaba-PuHuiTi-Medium.ttf')
}
@font-face {
  font-family: 'Alibaba PuHuiTi Bold';
  src: url('https://cdn.vcbeat.top/upload/vcbeat/vbList2020/font/Alibaba-PuHuiTi-Bold.ttf')
}
@font-face {
  font-family: 'Alibaba PuHuiTi Heavy';
  src: url('https://cdn.vcbeat.top/upload/vcbeat/vbList2020/font/Alibaba-PuHuiTi-Heavy.ttf')
}
@font-face {
  font-family: 'Alibaba PuHuiTi Light';
  src:  url('https://cdn.vcbeat.top/upload/vcbeat/vbList2020/font/Alibaba-PuHuiTi-Light.ttf')
}
@font-face {
  font-family: 'Alibaba PuHuiTi Regular';
  src:  url('https://cdn.vcbeat.top/upload/vcbeat/vbList2020/font/Alibaba-PuHuiTi-Regular.ttf')
}

#app 
  font-family: 'Alibaba PuHuiTi Regular';
</style>
